import type { Dispatch, SetStateAction } from 'react'
import { createContext } from 'react'

export type VisibilityStepsContextData = {
  isOpen: boolean
  callback?: () => void
  step?:
    | 'shipping_options'
    | 'logo'
    | 'support_email'
    | 'payment_provider'
    | 'published_product'
    | 'store_address'
    | 'unpublish'
}

export type VisibilityStepsContextType = [
  VisibilityStepsContextData,
  Dispatch<SetStateAction<VisibilityStepsContextData>>,
]

export const VisibilityStepsContext = createContext<VisibilityStepsContextType>(
  [
    {
      isOpen: false,
      callback: () => {},
    },
    () => {},
  ]
)
